import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./About.css";
 import icons from "./assets/icons.png";

function About() {
  const aboutRef = useRef(null);

  useEffect(() => {
  const elements = document.querySelectorAll(
    ".animate-left, .animate-up, .animate-right"
  );

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
        }
      });
    },
    { threshold: 0.2 }
  );

  elements.forEach(el => observer.observe(el));
}, []);


  return (
<section className="about-me-section">
  <h2 className="about-me-title fade-in">About Me</h2>
  <p className="about-me-text">
    With over 40 years of hands-on industry experience, I specialise in delivering safe,
    efficient, and compliant plumbing and heating solutions. I hold Gas Safe certification,
    G3 unvented qualification, Heat Pump Level 3 BPEC accreditation, and WRAS approval.
    These qualifications ensure every installation, repair, and system upgrade is carried
    out to the highest professional standard, with a focus on long-term reliability,
    performance, and customer safety.
  </p>

  <div className="about-me-icons">
   

<img src={icons} alt="Qualification Icons" />
  </div>

<div className="about-me-contact-btn">
  <Link to="/contact" className="contact-button">Get in Touch</Link>

</div>



</section>








  );
}

export default About;

